import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router";
import { Form } from "antd";
import { useAppDispatch, useAppSelector } from "../../../..";
import { TypesCharacteristicsObjectList } from "../TypesCharacteristicsObjectList/TypesCharacteristicsObjectList";
import { checkIsLoaded, toHttpFormatStartOfDay } from "../../../../lib/utils";
import { ITypesCharacteristicsObjectListSearch } from "../../types/TypesCharacteristicsObjectListSearch";
import { ITypesCharacteristicsObjectContext } from "../../context/TypesCharacteristicsObjectContext/types";
import { TypesCharacteristicsObjectContext } from "../../context/TypesCharacteristicsObjectContext/TypesCharacteristicsObjectContext";
import {
  fetchTypesCharacteristicsObjectAccessModesDic,
  fetchTypesCharacteristicsObjectObjectTypesDic,
  fetchTypesCharacteristicsRangeTypesDic,
  fetchTypesCharacteristicsTypesDic,
  fetchTypesCharacteristicsTypesStorageDic,
  fetchTypesCharacteristicsTypesUnitsDic,
  fetchTypesCharacteristicsTypesValuesDic,
  fetchTypesCharacteristicsViewModeMaskDic,
  searchTypesCharacteristicsObject,
  fetchTypesCharacteristicsTypesDataDic,
} from "../../store/slice/typesCharacteristicsSlice";
import { TypesCharacteristicsObjectCreate } from "../TypesCharacteristicsObjectCreate/TypesCharacteristicsObjectCreate";
import { TypesCharacteristicsObjectView } from "../TypesCharacteristicsObjectView/TypesCharacteristicsObjectView";
import { hasAccess } from "../../../../components/RolesModule/hasAccess";
import { MENU_ADMIN_OBJECT_CHAR_TYPE_WRITE } from "../../../../lib/const/permissions";
import "./TypesCharacteristicsObjectContainer.less";

export const TypesCharacteristicsObjectContainer = () => {
  const dispatch = useAppDispatch();
  const {
    typesCharacteristicsTypesDataDicLoading,
    typesCharacteristicsTypesDicLoading,
    typesCharacteristicsTypesValuesDicLoading,
    typesCharacteristicsTypesUnitsDicLoading,
    typesCharacteristicsRangeTypesDicLoading,
    typesCharacteristicsObjectObjectTypesDicLoading,
    typesCharacteristicsObjectAccessModesDicLoading,
    typesCharacteristicsTypesStorageDicLoading,
    typesCharacteristicsViewModeMaskDicLoading,
  } = useAppSelector((store) => store.typesCharacteristicsObject);

  // Загрузка справочников
  useEffect(() => {
    if (!checkIsLoaded(typesCharacteristicsTypesDataDicLoading))
      dispatch(fetchTypesCharacteristicsTypesDataDic());
    if (!checkIsLoaded(typesCharacteristicsTypesDicLoading))
      dispatch(fetchTypesCharacteristicsTypesDic());
    if (!checkIsLoaded(typesCharacteristicsTypesValuesDicLoading))
      dispatch(fetchTypesCharacteristicsTypesValuesDic());
    if (!checkIsLoaded(typesCharacteristicsTypesUnitsDicLoading))
      dispatch(fetchTypesCharacteristicsTypesUnitsDic());
    if (!checkIsLoaded(typesCharacteristicsRangeTypesDicLoading))
      dispatch(fetchTypesCharacteristicsRangeTypesDic());
    if (!checkIsLoaded(typesCharacteristicsObjectAccessModesDicLoading))
      dispatch(fetchTypesCharacteristicsObjectAccessModesDic());

    //----------

    if (!checkIsLoaded(typesCharacteristicsObjectObjectTypesDicLoading))
      dispatch(fetchTypesCharacteristicsObjectObjectTypesDic());
    if (!checkIsLoaded(typesCharacteristicsTypesStorageDicLoading))
      dispatch(fetchTypesCharacteristicsTypesStorageDic());
    if (!checkIsLoaded(typesCharacteristicsViewModeMaskDicLoading))
      dispatch(fetchTypesCharacteristicsViewModeMaskDic());
  }, []);

  // Загрузка типов характеристик (объект) по входу
  useEffect(() => {
    handleTypesCharacteristicsObjectListSearch({});
  }, []);

  const [isSearchOpen, setIsSearchOpen] = useState(true);
  const toggleSearchOpen = () => {
    setIsSearchOpen((prev) => !prev);
  };

  const [
    typesCharacteristicsObjectListSearchForm,
  ] = Form.useForm<ITypesCharacteristicsObjectListSearch>();

  const handleTypesCharacteristicsObjectListSearch = (params?: {
    page?: number;
    size?: number;
  }) => {
    const values: ITypesCharacteristicsObjectListSearch = typesCharacteristicsObjectListSearchForm.getFieldsValue();

    dispatch(
      searchTypesCharacteristicsObject({
        ...values,
        onDate: values.onDate ? toHttpFormatStartOfDay(values.onDate) : undefined,
      })
    );
  };

  const contextValue: ITypesCharacteristicsObjectContext = {
    isSearchOpen,
    toggleSearchOpen,
    handleTypesCharacteristicsObjectListSearch,
    typesCharacteristicsObjectListSearchForm,
  };

  return (
    <TypesCharacteristicsObjectContext.Provider value={contextValue}>
      <div className="container_height inner-row types-characteristics-object-container">
        <Switch>
          <Route path="/types-characteristics-object" exact>
            <TypesCharacteristicsObjectList />
          </Route>
          {hasAccess(MENU_ADMIN_OBJECT_CHAR_TYPE_WRITE) && (
            <Route path="/types-characteristics-object/create/:charTypeId" exact>
              <TypesCharacteristicsObjectCreate />
            </Route>
          )}
          {hasAccess(MENU_ADMIN_OBJECT_CHAR_TYPE_WRITE) && (
            <Route path="/types-characteristics-object/create" exact>
              <TypesCharacteristicsObjectCreate />
            </Route>
          )}
          <Route path="/types-characteristics-object/:objectTypeId/:objectCharTypeId" exact>
            <TypesCharacteristicsObjectView />
          </Route>
        </Switch>
      </div>
    </TypesCharacteristicsObjectContext.Provider>
  );
};
